import { useState } from "react";
import { toast } from "sonner";
import { apiClient } from "@/lib/api";

const CATEGORIAS = [
  { key: "puntualidad", label: "Puntualidad", desc: "¿Llegaron/respondieron a tiempo?" },
  { key: "trato", label: "Trato del personal", desc: "¿Fueron amables y profesionales?" },
  { key: "resolucion", label: "Resolución", desc: "¿Resolvieron tu problema?" },
  { key: "comunicacion", label: "Comunicación", desc: "¿Te mantuvieron informado?" },
];

function StarInput({ value, onChange, testId }) {
  return (
    <div style={{ display: "flex", gap: 4 }} data-testid={testId}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          onClick={() => onChange(n)}
          aria-label={`${n} estrellas`}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 2,
            fontSize: 26,
            color: n <= value ? "#F59E0B" : "#D1D5DB",
            transition: "color .15s",
          }}
        >
          <i className={n <= value ? "fas fa-star" : "far fa-star"} />
        </button>
      ))}
    </div>
  );
}

export default function EvaluacionModal({ solicitud, onClose, onSubmitted }) {
  const [form, setForm] = useState({
    puntualidad: 0,
    trato: 0,
    resolucion: 0,
    comunicacion: 0,
    nps: 5,
    comentario: "",
  });
  const [saving, setSaving] = useState(false);
  const [result, setResult] = useState(null); // {is_promoter}

  const canSubmit =
    form.puntualidad > 0 && form.trato > 0 && form.resolucion > 0 && form.comunicacion > 0;

  const submit = async (e) => {
    e.preventDefault();
    if (!canSubmit) {
      toast.error("Califica las 4 categorías con estrellas antes de enviar");
      return;
    }
    setSaving(true);
    try {
      const { data } = await apiClient.post(`/solicitudes/${solicitud.id}/evaluar`, form);
      setResult(data);
      toast.success("¡Gracias por tu evaluación! 🙏");
      if (onSubmitted) onSubmitted(data);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "No pudimos guardar tu evaluación");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      style={{
        position: "fixed", inset: 0, background: "rgba(15,23,42,.65)",
        display: "flex", alignItems: "center", justifyContent: "center",
        zIndex: 1000, padding: 16, backdropFilter: "blur(2px)",
      }}
      onClick={onClose}
      data-testid="evaluacion-modal"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "white", borderRadius: 16, padding: 28,
          maxWidth: 560, width: "100%", maxHeight: "90vh", overflowY: "auto",
          boxShadow: "0 24px 48px rgba(0,0,0,.3)",
        }}
      >
        {!result ? (
          <>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
              <div>
                <h2 style={{ margin: 0, color: "#163680", fontSize: 22 }}>¿Cómo nos fue?</h2>
                <p style={{ margin: "4px 0 0", color: "#6b7280", fontSize: 13 }}>
                  Servicio de <strong>{(solicitud.tipo || "").toUpperCase()}</strong> para {solicitud?.beneficiario?.nombre || "tu beneficiario"}
                </p>
              </div>
              <button onClick={onClose} data-testid="evaluacion-close-btn" aria-label="Cerrar"
                style={{ background: "none", border: "none", fontSize: 22, cursor: "pointer", color: "#94a3b8" }}>
                ×
              </button>
            </div>

            <form onSubmit={submit} style={{ marginTop: 18 }}>
              {CATEGORIAS.map((cat) => (
                <div key={cat.key} style={{ marginBottom: 16, padding: 12, background: "#F8FAFC", borderRadius: 10 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8 }}>
                    <div>
                      <div style={{ fontWeight: 600, color: "#0f172a" }}>{cat.label}</div>
                      <div style={{ color: "#6b7280", fontSize: 12 }}>{cat.desc}</div>
                    </div>
                    <StarInput
                      value={form[cat.key]}
                      onChange={(v) => setForm((s) => ({ ...s, [cat.key]: v }))}
                      testId={`stars-${cat.key}`}
                    />
                  </div>
                </div>
              ))}

              <div style={{ marginBottom: 16 }}>
                <label style={{ fontWeight: 600, color: "#0f172a", display: "block", marginBottom: 6 }}>
                  ¿Recomendarías nuestro servicio? <span style={{ color: "#6b7280", fontWeight: 400, fontSize: 12 }}>(0 = nada, 10 = totalmente)</span>
                </label>
                <input
                  type="range" min="0" max="10" step="1"
                  value={form.nps}
                  onChange={(e) => setForm((s) => ({ ...s, nps: Number(e.target.value) }))}
                  style={{ width: "100%", accentColor: "#163680" }}
                  data-testid="nps-slider"
                />
                <div style={{ display: "flex", justifyContent: "space-between", fontSize: 11, color: "#94a3b8" }}>
                  <span>0</span><span>5</span><span>10</span>
                </div>
                <div style={{ textAlign: "center", fontSize: 20, fontWeight: 700, color: "#163680", marginTop: 4 }}>
                  {form.nps}/10
                </div>
              </div>

              <div style={{ marginBottom: 16 }}>
                <label style={{ fontWeight: 600, color: "#0f172a", display: "block", marginBottom: 6 }}>
                  Comentario <span style={{ color: "#6b7280", fontWeight: 400, fontSize: 12 }}>(opcional)</span>
                </label>
                <textarea
                  value={form.comentario}
                  onChange={(e) => setForm((s) => ({ ...s, comentario: e.target.value }))}
                  rows={3} maxLength={500}
                  placeholder="Cuéntanos qué te pareció el servicio…"
                  style={{ width: "100%", padding: 10, border: "1px solid #cbd5e1", borderRadius: 8, fontFamily: "inherit", fontSize: 14, resize: "vertical" }}
                  data-testid="evaluacion-comentario"
                />
              </div>

              <button
                type="submit" disabled={!canSubmit || saving}
                data-testid="evaluacion-submit-btn"
                style={{
                  width: "100%", padding: "14px 20px", background: "#163680",
                  color: "white", border: "none", borderRadius: 10, fontWeight: 700, fontSize: 15,
                  cursor: canSubmit && !saving ? "pointer" : "not-allowed",
                  opacity: canSubmit && !saving ? 1 : 0.5,
                }}
              >
                {saving ? "Enviando…" : "Enviar evaluación"}
              </button>
            </form>
          </>
        ) : (
          <div style={{ textAlign: "center", padding: "12px 0" }}>
            <div style={{ fontSize: 56, marginBottom: 8 }}>🙏</div>
            <h2 style={{ margin: 0, color: "#163680" }}>¡Gracias por tu opinión!</h2>
            <p style={{ color: "#374151", marginTop: 8 }}>
              Tu evaluación nos ayuda a mejorar el servicio para todos.
            </p>
            {result.is_promoter && (
              <div
                style={{
                  background: "linear-gradient(135deg, #FEF3C7, #FDE68A)",
                  borderRadius: 12, padding: 20, marginTop: 20, textAlign: "left",
                }}
                data-testid="promoter-referral-cta"
              >
                <h3 style={{ margin: "0 0 8px", color: "#92400E" }}>
                  ⭐ ¡Eres un cliente increíble!
                </h3>
                <p style={{ margin: "0 0 12px", color: "#78350F", fontSize: 14 }}>
                  Compartir con un amigo o familiar les puede salvar el día — y a ti te regalamos <strong>30 días GRATIS</strong> por cada persona que se una.
                </p>
                <a
                  href="/cuenta/referidos"
                  style={{ display: "inline-block", background: "#B45309", color: "white", padding: "10px 20px", borderRadius: 8, textDecoration: "none", fontWeight: 700, fontSize: 14 }}
                  data-testid="referral-cta-link"
                >
                  Invitar y ganar 30 días →
                </a>
              </div>
            )}
            {result.average_rating <= 2.0 && (
              <div
                style={{
                  background: "#FEF2F2", borderLeft: "4px solid #DC2626",
                  borderRadius: 8, padding: 14, marginTop: 20, textAlign: "left",
                  color: "#7F1D1D", fontSize: 13, lineHeight: 1.5,
                }}
                data-testid="bad-service-notice"
              >
                Nuestro equipo ya recibió tu reporte y se pondrá en contacto contigo muy pronto para resolver lo que salió mal.
              </div>
            )}
            <button
              onClick={onClose}
              data-testid="evaluacion-close-final"
              style={{
                marginTop: 24, background: "#f1f5f9", color: "#0f172a", border: "none",
                padding: "10px 24px", borderRadius: 8, fontWeight: 600, cursor: "pointer",
              }}
            >
              Cerrar
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
